import { searchPageByType } from '../common/utils/incrementalSearchPages';
import { TimelineRefreshError } from './TimelineRefreshError';
import { validateTimelineRefreshTimestamp } from './timelineRefreshTimestamp';

export const fetchTimelineUpdates = async (
    entity: string,
    ownerId: string,
    lastFetchedAt: unknown,
    signal?: AbortSignal,
    additionalFragmentName?: string
): Promise<any[]> => {
    signal?.throwIfAborted();
    const updatedSince = validateTimelineRefreshTimestamp(entity, lastFetchedAt);

    try {
        const pages = searchPageByType(entity, {
            activeOrganizationAccount: ownerId,
            batchSize: 50,
            filters: [{ filters: [{ identifier: 'updatedOn', dateMin: updatedSince }], sortBy: 'updatedOn_ASC' }],
            setBatchState: () => undefined,
            includeAllActions: entity === 'Activity',
            additionalFragmentName,
            signal,
            requireCompleteResults: true
        });
        const results = (await Promise.all(pages)).flat();
        signal?.throwIfAborted();
        return results;
    } catch (cause) {
        if (signal?.aborted) throw cause;
        const errorLoadingTimelineUpdates = new TimelineRefreshError(entity, cause);
        throw errorLoadingTimelineUpdates;
    }
};
